export default __webpack_public_path__ + "static/media/FavoritesHeader.c75585ac.svg";